import React, { useState } from 'react';
import { CardElement } from '@stripe/react-stripe-js';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import propTypes from 'prop-types';
import { StyledButton } from '../Generics.styled';

const PaymentForm = (props) => {
    const {
        buttonIsDisabled,
        buttonLabel,
        buttonStyle,
        buttonHeight,
        buttonWidth,
        onPayButtonSubmit,
    } = props;

    const [paymentData, setPaymentData] = useState({
        error: false,
        message: '',
        messageColor: 'red',
        disableButton: true,
    });

    const handleOnChange = (e) => {
        setPaymentData({ error: false, message: '' });
        const formIsComplete = e.complete;

        if (!formIsComplete) {
            setPaymentData({
                disableButton: true,
                error: true,
                message: 'Credit card information is invalid or missing.',
                messageColor: 'red',
            });
        }
    };
    return (
        <div style={{ maxWidth: 400 }}>
            <CardElement onChange={(e) => handleOnChange(e)} />
            <div style={buttonStyle}>
                <StyledButton
                    style={{ height: buttonHeight, width: buttonWidth }}
                    disabled={buttonIsDisabled || paymentData.disableButton}
                    variant="contained"
                    color="primary"
                    onClick={onPayButtonSubmit}
                >
                    {buttonLabel}
                </StyledButton>
            </div>

            <div style={{ color: paymentData.messageColor, marginTop: '20px' }}>
                {paymentData.message}
            </div>

            <br />
        </div>
    );
};

PaymentForm.propTypes = {
    buttonIsDisabled: propTypes.bool,
    buttonLabel: propTypes.node,
    buttonStyle: propTypes.shape({}),
    buttonHeight: propTypes.string,
    buttonWidth: propTypes.string,
    onPayButtonSubmit: propTypes.func,
};

PaymentForm.defaultProps = {
    paymentAmmount: 0,
    onPayButtonSubmit: () => {},
    buttonIsDisabled: false,
    submitHandler: () => {},
    buttonLabel: <div />,
    buttonStyle: {},
    buttonHeight: '50px',
    buttonWidth: '450px',
};

export default PaymentForm;
